// src/data/loadVocabPair.js
import { loadConcepts } from "./loadConcepts";
import { loadTranslations } from "./loadTranslations";

/**
 * Lädt ein Vokabel-Sprachpaar: Konzepte + Übersetzungen beider Sprachen, gejoint über die
 * gemeinsame Concept-ID. Generischer Einstiegspunkt für beliebige Sprachpaare, liefert
 * Wort-Objekte mit source/target statt fester es/de-Felder.
 *
 * Konzepte, für die eine der beiden Sprachen keine Übersetzung hat, werden übersprungen
 * (lieber ein vollständiges, kleineres Set als Lücken in der Lernkarte).
 *
 * sourceLang ist die Lernsprache (language_id "es-de": Spanisch lernen), ihr Häufigkeitsrang
 * bestimmt freqRank/freqRankType und damit die Reihenfolge der Wochensets.
 */
export async function loadVocabPair(sourceLang, targetLang) {
  const [concepts, sourceMap, targetMap] = await Promise.all([
    loadConcepts(sourceLang),
    loadTranslations(sourceLang),
    loadTranslations(targetLang),
  ]);

  const pairs = concepts
    .map((concept) => {
      const source = sourceMap.get(concept.id);
      const target = targetMap.get(concept.id);
      if (!source || !target) return null;
      return { ...concept, source, target };
    })
    .filter(Boolean);

  console.log(`[Fluent] Vokabel-Paar ${sourceLang}-${targetLang} geladen:`, pairs.length);
  return pairs;
}
